import { Button, Grid, styled, Typography } from '@mui/material';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Column } from 'further-ui/components/Layout';
import Table from 'further-ui/components/Table';
import { ActionRefLabels } from 'further-ui/labels';
import { CalendarDay, numberToCurrencyString } from 'further-ui/utils';
import { useState } from 'react';

const TextButton = styled(Button)({
  padding: 0,
  width: 'auto',
  minWidth: 0,
});

const actionHistoryColumns = [
  {
    key: 'date',
    label: 'Date',
  },
  {
    key: 'actionRef',
    label: 'Action',
  },

  {
    key: 'amountLcy',
    label: 'Funds received',
  },
];

type Props = {
  baseCurrency: CurrencyCode;
  actionHistory: Array<{
    actionRef: string;
    actionId: string;
    amountLcy?: number | null;
    date: CalendarDay;
  }>;
};

const DistributableActionsHistory: React.FC<Props> = ({
  actionHistory,
  baseCurrency,
}) => {
  const [showActionHistory, setShowActionHistory] = useState(false);

  const rows = actionHistory.map((action) => ({
    id: action.actionId,
    actionRef: ActionRefLabels[action.actionRef],
    date: action.date.toLabel(),
    amountLcy: numberToCurrencyString(action.amountLcy, {
      currency: baseCurrency,
    }),
  }));

  return (
    <Column spacing="md">
      <Typography variant="body2">
        Click{' '}
        <TextButton
          variant="text"
          onClick={() => setShowActionHistory(!showActionHistory)}
        >
          here
        </TextButton>{' '}
        to {showActionHistory ? 'hide' : 'view'} your distributable transaction
        history.
      </Typography>
      {showActionHistory && (
        <Grid container>
          <Grid size={{ xs: 12, md: 6 }}>
            <Table
              columns={actionHistoryColumns}
              rows={rows}
              emptyMessage="No distributable transactions"
            />
          </Grid>
        </Grid>
      )}
    </Column>
  );
};

export default DistributableActionsHistory;
